nsr.controller('AdminGroundfloorAccountController', [
    '$scope', '$http', '$timeout', 'Admin', '$auth', '$state', 'UserService', 'TransitionService',
    function ($scope, $http, $timeout, Admin, $auth, $state, UserService, TransitionService) {
        var settings = {};

        $scope.slideoverWidth = '500px';

        $scope.search = {
            description: ''
        };

        $scope.slideovers = {
            account: false,
            upload: false
        };

        $scope.accounts = [];

        $scope.loadAccounts = function () {
            Admin.get('groundfloor-manage').then(function (response) {
                settings = response.data.settings;
                $scope.accounts = response.data;
            });
        }

        $scope.loadAccounts();

        // var flagStyle = {'color': 'red'};
        // var noStyle = {};
        // $scope.flagColumn = function (testCondition) {
        //     return (testCondition) ? flagStyle : noStyle;
        // };

        $scope.addAccount = function () {
            if (window.innerWidth < 500) {
                $scope.slideoverWidth = window.innerWidth + 'px';
            } else {
                $scope.slideoverWidth = 500 + 'px';
            }

            $scope.account = { vendor_id: 12 };

            $scope.slideovers.account = true;
        };

        $scope.loginAs = function (userId) {
            bootbox.confirm("This will end your current session and login you as the following investor, proceed?", function (r) {
                if (r) {
                    Admin.get('login-as/' + userId).then(function (response) {
                        $auth.setToken(response.data.auth_token);
                        TransitionService.showToastUntilCompleted(UserService.initUser(), "Switching user...").then(function () {
                            $state.go('dashboard', {}, {reload: true});
                        });
                    });
                }
            })
        };

        $scope.uploadData = function (account) {
            if (window.innerWidth < 500) {
                $scope.slideoverWidth = window.innerWidth + 'px';
            } else {
                $scope.slideoverWidth = 500 + 'px';
            }

            $scope.account = account;
            $scope.slideovers.upload = true;
        };

        $scope.refreshBalances = function (account) {
            TransitionService.showToastUntilCompleted(Admin.post('groundfloor-update-balances/' + account), "Refreshing Balances...").then(function () {
                $scope.loadAccounts();
            });
        }

        $scope.showData = function (account) {
            if (account.details) {
                account.details = !account.details;
                account.detailsData = null;
            } else {
                TransitionService.showToastUntilCompleted(Admin.post('groundfloor-get-data/' + account.account_id), "Loading...").then(function (response) {
                    account.details = !account.details;
                    account.detailsData = response.data;
                })
            }
        }

        $scope.clearBalances = function (account) {
            bootbox.confirm("Are you sure you want to delete all balance records? After that you will be able to calculate the data again.", function (r) {
                if (r) {
                    TransitionService.showToastUntilCompleted(Admin.post('groundfloor-clear-all-balances/' + account.account_id), "Deleting balances data...").then(function () {
                        $scope.loadAccounts();
                    })
                }
            })
        }

        $scope.clearAllData = function (account) {
            bootbox.confirm("Transaction data, portfolio data, transfers and balances will be deleted. This action cannot be undone. Are you sure you want to delete all account data?", function (r) {
                if (r) {
                    TransitionService.showToastUntilCompleted(Admin.post('groundfloor-clear-all-data/' + account.account_id), "Deleting account data...").then(function () {
                        $scope.loadAccounts();
                    })
                }
            })
        }

        $scope.deleteAccount = function (account) {
            bootbox.confirm("Are you sure you want to delete the account and all data associated with it? This action cannot be undone.", function (r) {
                if (r) {
                    TransitionService.showToastUntilCompleted(Admin.post('groundfloor-delete-account/' + account.account_id), "Deleting account with all data...").then(function () {
                        $scope.loadAccounts();
                    })
                }
            })
        }
    }]);

nsr.controller('AdminGroundfloorAddAccountController', ['$scope', '$http', '$timeout', 'Admin', '$auth', '$state', '$stateParams', '$uibModal', 'GrounfloorAccountService', 'AccountSingletonService', function ($scope, $http, $timeout, Admin, $auth, $state, $stateParams, $uibModal, GrounfloorAccountService, AccountSingletonService) {
    // $scope.account = AccountSingletonService.getAccount();
    $scope.vendorList = $scope.vendors.list().filter(v => v.vendor_id === 12);

    $scope.changeUser = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: '_change_user.html',
            controller: 'ChangeUserController',
            size: 'lg',
        });

        modalInstance.result.then(function (user_id) {
            $scope.account.user_id = user_id;
        }, function () {

        });
    };

    $scope.save = function () {
        GrounfloorAccountService.create($scope.account).success(function () {
            $scope.$parent.slideovers.account = false;
            $scope.$parent.loadAccounts();
        });
    };
}]);

nsr.controller('ChangeUserController', ['$scope', '$controller', '$uibModalInstance', 'ErrorHandler', function ($scope, $controller, $uibModalInstance, ErrorHandler) {
    angular.extend(this, $controller('AdminUserController', {$scope: $scope}));

    $scope.ok = function(user_id) {
        $uibModalInstance.close(user_id);
    };

    $scope.cancel = function () {
        ErrorHandler.clearErrors();
        $uibModalInstance.dismiss('cancel');
    };
}]);

nsr.controller('AdminGroundfloorUploadController', ['$scope', 'Admin', '$http', function ($scope, Admin, $http) {
    $scope.file = null;

    $scope.saveTransactions = function() {
        var fd = new FormData();

        fd.append('account_id', $scope.account.account_id)

        angular.forEach($scope.uploadtransactions, function (file) {
            fd.append('file', file);
        });

        Admin.post('groundfloor-upload-transactions', fd, true).success(function () {
            $scope.$parent.slideovers.upload = false;
            $scope.$parent.loadAccounts();
            $scope.file = null;
        })
    }

    $scope.saveNotes = function() {
        var fd = new FormData();

        fd.append('account_id', $scope.account.account_id)

        angular.forEach($scope.uploadnotes, function (file) {
            fd.append('file', file);
        });

        Admin.post('groundfloor-upload-notes', fd, true).success(function () {
            $scope.$parent.slideovers.upload = false;
            $scope.$parent.loadAccounts();
            $scope.file = null;
        })
    }
}]);